// Boot wrapping order per design/30-engineering/ui-implementation/_phase2/foundation/brief.md §3:
//
//   <SkipLinks/>                     ← FIRST DOM node before logo
//   <LiveRegionProvider>             ← polite + assertive slots at body root
//     <DrawerHostRoot>               ← single-drawer-at-a-time portal
//       <RouterProvider router />    ← data-router API per architecture.md §3.1
//
// The skip-link order is "Skip to map", "Skip to layers", "Skip to copilot"
// per A11y plan §A.3 (Google convention: skip-links first DOM child of <body>
// before any platform-shell logo).
//
// Material Symbols Rounded font face: loaded by frontend/src/styles/material-symbols.css.
// - Cloud variant: imports from Google Fonts CDN.
// - Defence variant: replaces the import with self-hosted woff2 in
//   frontend/public/fonts/material-symbols-rounded.woff2 at build time
//   (vite.config.defence.ts; dependency-policy.md §4.2).

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { SkipLinks } from '@/design';
import { LiveRegionProvider } from '@/state/liveRegion';
import { DrawerHostRoot } from '@/state/drawerHost';
import { ReadOnlyBanner } from '@/components/share/ReadOnlyBanner';
import { routes } from './routes';

const router = createBrowserRouter(routes);

export function App() {
  return (
    <>
      <SkipLinks />
      <ReadOnlyBanner />
      <LiveRegionProvider>
        <DrawerHostRoot>
          <RouterProvider router={router} />
        </DrawerHostRoot>
      </LiveRegionProvider>
    </>
  );
}
